/** Coerce form field values to strings for routing, maps, and numbro. */
export function coerceToString(value: unknown): string {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return '';
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isFormikFieldErrorSection(
  value: unknown
): value is Record<string, string | undefined> {
  return isRecord(value);
}

export function readInformationStartDate(
  values: Record<string, unknown>
): string | undefined {
  const information = values.information;
  if (!isRecord(information)) {
    return undefined;
  }
  return typeof information.start === 'string' ? information.start : undefined;
}

export function readCo2KindOfCertificate(
  values: Record<string, unknown>
): string | undefined {
  const co2CertificateData = values.co2CertificateData;
  if (!isRecord(co2CertificateData)) {
    return undefined;
  }
  return typeof co2CertificateData.kindOfCertificate === 'string'
    ? co2CertificateData.kindOfCertificate
    : undefined;
}
